export const OFFERING_KEYS = {
  MEDICATION: 'medication',
  MEDICATION_99: 'medication_99',
  MEDICATION_THERAPY: 'medication-therapy',
  THERAPY: 'therapy',
  COUPLES_THERAPY: 'couples_therapy',
  FIRST_AD_HOC_THERAPY: 'first-ad-hoc-therapy',
  MEDICATION_CARE_MANAGEMENT_B2B: 'medication_care_management_b2b',
  MEDICATION_CARE_MANAGEMENT_65_B2B: 'medication_care_management_65_b2b',
  MEDICATION_CARE_MANAGEMENT_INSURANCE_B2B: 'medication_care_management_insurance_b2b',
  COUNSELING: 'counseling',
  MEDICATION_MANAGEMENT: 'medication_management',
  MEDICATION_COACHING: 'medication-coaching',
  COACHING: 'coaching',
  MAT_COUNSELING: 'mat-counseling',
  MEDICATION_FIRST_AD_HOC_THERAPY: 'medication-first-ad-hoc-therapy',
  MEDICATION_SECOND_AD_HOC_THERAPY: 'medication-second-ad-hoc-therapy',
  MEDICATION_COACHING_ABTEST: 'medication-coaching-abtest',
  COACHING_ABTEST: 'coaching-abtest'
} as const;
